export default {"spin":"_8JiuKa_spin","loader":"_8JiuKa_loader",}